import {
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  Tooltip as TooltipRoot
} from '../shadcn/tooltip';

import type {ComponentProps, ReactNode} from 'react';

export interface TooltipProps {
  children: ReactNode;
  content?: ReactNode;
  side?: ComponentProps<typeof TooltipContent>['side'];
  align?: ComponentProps<typeof TooltipContent>['align'];
}

export function Tooltip({children, content, side, align}: TooltipProps) {
  if (content == null) {
    return <>{children}</>;
  }

  return (
    <TooltipProvider>
      <TooltipRoot>
        <TooltipTrigger render={<span className="inline-flex max-w-full" />}>
          {children}
        </TooltipTrigger>
        <TooltipContent side={side} align={align}>
          {content}
        </TooltipContent>
      </TooltipRoot>
    </TooltipProvider>
  );
}
